import React from 'react'
import '../css/pages/form.css'

const EditForm = ({title, description, children}) => (
  <form onSubmit={e => e.preventDefault()}>
    <div className="description">{description}</div>
    {children}
  </form>
)

export default EditForm
